import { useEffect, useState } from 'react';
import { getSettings, DEFAULT_SPORT_CONFIG, type ResolvedSportConfig } from '../api/client';

/**
 * The club's resolved sport config (positions, staff roles, score label…),
 * fetched once per session from /admin/settings and shared by every page.
 * Renders with the football fallback until the response lands, so dropdowns
 * are never empty. Call invalidateSportConfig() after the sport is changed.
 */
let cache: ResolvedSportConfig | null = null;
let inflight: Promise<ResolvedSportConfig> | null = null;

export function invalidateSportConfig(): void {
  cache = null;
  inflight = null;
}

export function useSportConfig(): ResolvedSportConfig {
  const [config, setConfig] = useState<ResolvedSportConfig>(cache || DEFAULT_SPORT_CONFIG);
  useEffect(() => {
    let live = true;
    if (cache) { setConfig(cache); return; }
    if (!inflight) {
      inflight = getSettings().then(s => s.sportConfig || DEFAULT_SPORT_CONFIG);
    }
    inflight.then(c => { cache = c; if (live) setConfig(c); }).catch(() => { /* keep the fallback */ });
    return () => { live = false; };
  }, []);
  return config;
}
